'use client';

import { useState } from 'react';
import { useBreakpoint, Conditional } from '@cat-ecom/pcc-components';
import { CategoryOrBuyingOption } from 'services/categories/types';
import { useTranslations } from 'next-intl';
import { ShopCategoryCard } from '../shop-category-card';
import { CatGrid, CatGridItem, CatButton } from 'components/blocks-components';
import { PAGE_BREAKPOINTS } from 'constants/common';
import styles from '../shop-category-card/shop-category-card.module.scss';

type ShopByCategoryWrapperProps = {
  categories: CategoryOrBuyingOption[];
};

export const ShopByCategoryWrapper = ({
  categories
}: Readonly<ShopByCategoryWrapperProps>) => {
  const t = useTranslations();
  const [viewAll, setViewAll] = useState(false);
  const isMD = useBreakpoint(PAGE_BREAKPOINTS.MD);
  const isSM = !useBreakpoint(PAGE_BREAKPOINTS.BLOCKS_SM);
  const previewCount = isSM ? 4 : 6;
  const showAllCategories = isMD || isMD === undefined;

  const categoriesList =
    viewAll || showAllCategories
      ? categories
      : categories.slice(0, previewCount);

  const handleViewAll = () => {
    if (viewAll) {
      document.getElementById('categories-section').scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
    setViewAll(!viewAll);
  };
  return (
    <>
      <div
        id="categories-section"
        className="cat-u-margin-top-xl d-flex flex-wrap"
        data-testid="shop-category-wrapper"
      >
        <CatGrid
          variant={'1-2-4up'}
          className="flex-sm-grow-0 flex-grow-1"
          gap={!showAllCategories ? 'xs' : 'sm'}
        >
          {categoriesList.map((card) => {
            return (
              <CatGridItem
                key={card.name}
                className={styles['shop-category-card-grid']}
              >
                {/* TODO: We will change this to Link component once Headless migration is completed */}
                <a
                  href={`${card.seoUrlKeyword}`}
                  className={'text-decoration-none'}
                  aria-label={card.name}
                >
                  <ShopCategoryCard
                    title={card.name}
                    imageUrl={card.imageUrl}
                  />
                </a>
              </CatGridItem>
            );
          })}
        </CatGrid>
      </div>

      <Conditional test={!showAllCategories}>
        <CatButton
          variant="ghost"
          size="sm"
          onClick={handleViewAll}
          className="d-flex justify-content-center mt-2"
        >
          {viewAll ? t('VIEW_LESS') : t('VIEW_ALL')}
        </CatButton>
      </Conditional>
    </>
  );
};

export default ShopByCategoryWrapper;
